import type { TemplateStatus } from '@cognite/apm-client';

export type TemplateStatusFilter = TemplateStatus | 'All';

const ALLOWED_TEMPLATE_STATUS: readonly TemplateStatusFilter[] = [
  'Draft',
  'Ready',
  'Deleted',
  'All',
];

export const isAllowedTemplateStatus = (
  value: string | null
): value is TemplateStatusFilter =>
  ALLOWED_TEMPLATE_STATUS.some((s) => s === value);
